"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const utils_1 = require("./utils");
const v0 = (0, utils_1.buildTypes)({
    types: {
        IpfsCid: "Text",
        WhoAndWhen: {
            account: "AccountId",
            block: "BlockNumber",
            time: "Moment",
        },
        User: {
            _enum: {
                Account: "AccountId",
                Space: "SpaceId",
            },
        },
        Content: {
            _enum: {
                None: "Null",
                Raw: "Text",
                IPFS: "Text",
                Hyper: "Text",
            },
        },
    }
});
exports.default = [v0];
